import {
  componentManifestValidator_default,
  require__
} from "./chunk-WGEOEJLG.js";
import {
  __toESM,
  componentManifestSchema_default
} from "./chunk-CBT2ZTXA.js";

// src/base/EditingBehaviors.base.ts
var import__ = __toESM(require__());
var EditingBehaviorsBase = class {
  constructor(editingBehaviors) {
    this.editingBehaviors = editingBehaviors || {};
  }
  static validate(editingBehaviors) {
    const ajv = new import__.default({ allErrors: true });
    const ajvValidate = ajv.compile(componentManifestSchema_default.$defs.editingBehaviors);
    const valid = ajvValidate(editingBehaviors);
    return {
      valid,
      errors: ajvValidate.errors
    };
  }
  setBehaviors(editingBehaviors) {
    this.editingBehaviors = editingBehaviors;
    return this;
  }
  getBehaviors() {
    return this.editingBehaviors;
  }
};
var EditingBehaviors_base_default = EditingBehaviorsBase;

// src/builder/EditingBehaviors.builder.ts
var EditingBehaviorsBuilder = class extends EditingBehaviors_base_default {
  constructor(editingBehaviors) {
    super(editingBehaviors);
  }
  build() {
    const { errors, valid } = EditingBehaviors_base_default.validate(this.editingBehaviors);
    if (!valid) {
      throw new Error(`Invalid manifest: ${JSON.stringify(errors)}`);
    }
    return this.editingBehaviors;
  }
};
var EditingBehaviors_builder_default = EditingBehaviorsBuilder;

// src/base/Style.base.ts
var import__2 = __toESM(require__());
var StyleBase = class {
  constructor(style) {
    this.style = style || {};
  }
  static validate(style) {
    const ajv = new import__2.default({ allErrors: true });
    const ajvValidate = ajv.compile(componentManifestSchema_default.$defs.style);
    const valid = ajvValidate(style);
    return {
      valid,
      errors: ajvValidate.errors
    };
  }
  setStyle(style) {
    this.style = style;
    return this;
  }
  getStyle() {
    return this.style;
  }
};
var Style_base_default = StyleBase;

// src/builder/Style.builder.ts
var StyleBuilder = class extends Style_base_default {
  constructor(style) {
    super(style);
  }
  build() {
    const { errors, valid } = Style_base_default.validate(this.style);
    if (!valid) {
      throw new Error(`Invalid manifest: ${JSON.stringify(errors)}`);
    }
    return this.style;
  }
};
var Style_builder_default = StyleBuilder;

// src/base/ComponentManifest.base.ts
var ComponentManifestBase = class _ComponentManifestBase {
  constructor(manifest) {
    this.manifest = manifest || {};
  }
  static validate(manifest) {
    return componentManifestValidator_default(manifest);
  }
  setDisplayName(displayName) {
    this.manifest.displayName = displayName;
    return this;
  }
  getDisplayName() {
    return this.manifest.displayName;
  }
  setSelector(selector) {
    this.manifest.selector = selector;
    return this;
  }
  getSelector() {
    return this.manifest.selector;
  }
  setReferredType(referredType) {
    this.manifest.referredType = referredType;
    return this;
  }
  getReferredType() {
    return this.manifest.referredType;
  }
  setEditingBehaviors(editingBehaviors) {
    if (!this.manifest.definitions) {
      this.manifest.definitions = {};
    }
    const isBuilder = editingBehaviors instanceof EditingBehaviors_builder_default;
    const behaviors = isBuilder ? editingBehaviors.build() : editingBehaviors;
    this.manifest.definitions.editingBehaviors = behaviors;
    return this;
  }
  getEditingBehaviors() {
    return this.manifest.definitions?.editingBehaviors;
  }
  setStyle(style) {
    if (!this.manifest.definitions) {
      this.manifest.definitions = {};
    }
    const isBuilder = style instanceof Style_builder_default;
    const constructedStyle = isBuilder ? style.build() : style;
    this.manifest.definitions.style = constructedStyle;
    return this;
  }
  getStyle() {
    return this.manifest.definitions?.style;
  }
  getElements() {
    return this.manifest.elements;
  }
  setElements(elements) {
    Object.keys(elements).forEach((key) => {
      const element = elements[key];
      this.setElement(key, element);
    });
    return this;
  }
  setElement(key, element) {
    if (!this.manifest.elements) {
      this.manifest.elements = {};
    }
    this.manifest.elements[key] = element instanceof _ComponentManifestBase ? element.getManifest() : element;
  }
  setPresets(presets) {
    this.manifest.presets = presets;
    return this;
  }
  getPresets() {
    return this.manifest.presets;
  }
  getManifest() {
    return this.manifest;
  }
  setManifest(manifest) {
    this.manifest = manifest;
    return this;
  }
};
var ComponentManifest_base_default = ComponentManifestBase;

export {
  EditingBehaviors_base_default,
  Style_base_default,
  ComponentManifest_base_default
};
//# sourceMappingURL=chunk-NDOS2GQF.js.map
